import Repository from "./Repository";

const resource="/stats";

export default {
    getFrontend(mapids){
        return Repository.get(resource+"/"+mapids+"/frontend");
    }
}